import { useQuery } from '@tanstack/react-query';
import { DateRange } from 'react-day-picker';

import { fetchTrades } from '@/lib/api/trades';
import { TimeWindow } from '@/types';

export type TradesDataOptions = {
  enabled?: boolean;
  dateRange?: DateRange;
};

export const useTradesData = (
  symbol: string,
  timeWindow: TimeWindow,
  options?: TradesDataOptions
) => {
  const { enabled = true, dateRange } = options ?? {};
  const from = dateRange?.from?.getTime();
  const to = dateRange?.to?.getTime();

  return useQuery({
    queryKey: ['trades', symbol, timeWindow, from, to],
    queryFn: ({ signal }) =>
      fetchTrades({
        symbol,
        timeWindow,
        from,
        to,
        signal,
      }),
    enabled: enabled && !!symbol && symbol !== 'N/A',
    staleTime: 0,
    gcTime: 0,
  });
};
